import Vue from 'vue';
import moment from "moment";
import bookingService from "./index";

const success = (context, response) => {
  context.contract.tenant_signature = context.api_url + '/images/signatures/' + response.data.image;
  context.contract.checking = moment(context.checkinDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
  context.contract.checkout = moment(context.checkoutDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
  !context.contract.id ? bookingService.createContract(context.contract, context) : bookingService.updateContract(context.contract, context);
  context.clearSignature();
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.loading = false;
};

export default (context, data) => {
  return Vue.$http.post('/files/upload-signature-image', data).then(response => {
    if(response && response.status === 200) {
      success(context, response);
    }
  }).catch(error => {
    failed(context, error);
  })
};



// WEBPACK FOOTER //
// ./src/app/services/booking/uploadContractSignatureImage.js